import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import invert from 'lodash.invert';
import { TemplateTab } from '../types/TemplateTabs';

export const VALID_APPLIED_FILTERS: TemplateTab[] = [
  DevelopmentTool.BLOCKS,
  DevelopmentTool.CLI,
  DevelopmentTool.DEV_CENTER,
];

export enum UrlParams {
  BLOCKS = 'blocks',
  CLI = 'cli',
  DEV_CENTER = 'self-hosted',
}

export const isValidAppliedFilter = (filter: TemplateTab) =>
  VALID_APPLIED_FILTERS.includes(filter);

export const filterToUrlParamMapper = {
  [DevelopmentTool.BLOCKS]: UrlParams.BLOCKS,
  [DevelopmentTool.CLI]: UrlParams.CLI,
  [DevelopmentTool.DEV_CENTER]: UrlParams.DEV_CENTER,
};

export const urlParamToFilterMapper = invert(filterToUrlParamMapper) as Record<
  UrlParams,
  TemplateTab
>;
